<template>
  <div>
    <div class="sa-mob-header">
      <h5 class="sa-card-tit">Chat History</h5>
      <button class="sa-btn-back" @click="$router.go(-1)">
        <i class="icon-arrow-left"></i>
      </button>
    </div>
    <div
      v-if="chatMsgs.length == 0"
      class="sa-d-f-a-center sa-d-f-j-center sa-h100"
    >
      <p>No Chat History</p>
    </div>
    <div v-else class="sa-h100" :class="minMaxPanel ? 'sa-d-f-sbetween' : ''">
      <div
        class="sa-chat-card"
        :class="minMaxPanel ? 'minimize' : ''"
        v-if="chatPanel"
      >
        <div class="sa-chat-history" ref="chatArea">
          <div class="sa-chat-about">
            <figure class="sa-avtar sa-avtar-md sa-h-xs">
              <img v-if="pimg" :src="pimg" alt="Doctor" class="sa-img-cover" />
              <img v-else :src="unknownImg" alt="Doctor" class="sa-img-cover" />
            </figure>
            <!-- <figure class="sa-avtar sa-avtar-sm">{{nameCaps(pname)}}</figure> -->
            {{ pname }}
            <!-- <small>Seems like the other end is on offline. So please wait for some time and <span class="sa-d-block">your chat will start shortly.</span></small> -->
          </div>
          <div
            v-for="(msg, index) in chatMsgs"
            :key="index"
            :class="
              msg.from == userInfo.uid
                ? 'sa-chat-msg sa-msg-doc'
                : 'sa-chat-msg sa-msg-pat'
            "
          >
            <figure
              class="sa-avtar sa-avtar-xs sa-h-xs"
              v-if="msg.from == userInfo.uid"
            >
              <img
                v-if="docImage"
                :src="docImage"
                alt="Doctor"
                class="sa-img-cover"
              />
              <img v-else :src="unknownImg" alt="Doctor" class="sa-img-cover" />
            </figure>
            <figure class="sa-avtar sa-avtar-xs sa-h-xs" v-else>
              <img v-if="pimg" :src="pimg" alt="Doctor" class="sa-img-cover" />
              <img v-else :src="unknownImg" alt="Doctor" class="sa-img-cover" />
            </figure>
            <span
              v-if="!(msg.from == userInfo.uid)"
              class="sa-online sa-online-small"
            ></span>
            <div class="sa-chat-msg-info">
              <div class="sa-chat-time">{{ chatTime(msg.created_at) }}</div>
              <div v-if="!msg.file_type" class="sa-chat-msg-text">
                {{ msg.body }}
              </div>
              <a
                v-else-if="isImage(msg.file_type)"
                :href="msg.body"
                target="_blank"
                class="sa-chat-msg-text sa-chat-msg-img"
              >
                <img :src="msg.body" class="sa-img-cover" />
              </a>
              <a
                v-else-if="msg.file_type == 'pdf'"
                :href="msg.body"
                target="_blank"
                class="sa-chat-msg-text sa-chat-msg-img"
              >
                <i class="icon-pdf"></i>
              </a>
              <a
                v-else
                :href="msg.body"
                target="_blank"
                class="sa-chat-msg-text"
                >{{ msg.body }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { socket_url } from "../../../config/endpoints";
import moment from "moment";
import chatAttachmentVue from "../common/chatAttachment.vue";
import _ from "lodash";
export default {
  components: {
    "chat-attachment": chatAttachmentVue,
  },
  mounted() {
    this.toggleBodyClass("addClass", "sa-chat-vdo");
    // initiate socket connection
    let _self = this;
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || null;
    if (_self.userInfo) {
      _self.docImage = _self.userInfo.img;
    }
    _self.fetchMessages();
  },
  data() {
    return {
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",
      imageFormat: [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "tif",
        "tiff",
        "eps",
        "raw",
        "cr2",
        "nef",
        "orf",
        "sr2",
        "PSD",
        "XCF",
        "AI",
        "CDR",
        "jfif",
      ],
      docImage: null,
      pimg: null,
      pname: null,
      doctorToken: null,
      patientToken: null,
      triggerCancel: false,
      appId: null,
      msgText: "",
      file_type: null,
      userInfo: null,
      chatMsgs: [],
      socket: null,
      socketId: null,
      localTrack: false,
      chatPanel: true,
      minMaxPanel: false,
      roomName: null,
      token: null,
      activeRoom: null,
      muteMic: false,
      unMuteMic: false,
      minMaxFlag: false,
      screenSize: false,
    };
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    isImage(fileType) {
      if (this.imageFormat.includes(fileType)) {
        return true;
      }
      return false;
    },
    setImg(uimg, flag) {
      let _self = this;
      if (uimg && uimg.filename) {
        _self.file_type = uimg.filename.split(".")[1] || null;
      }
      if (uimg && uimg.url) {
        _self.msgText = uimg.url;
      }
    },
    nameCaps(pname) {
      if (pname) {
        return (
          pname.charAt(0).toUpperCase() +
          (pname.split(" ")[1]
            ? pname.split(" ")[1].charAt(0).toUpperCase()
            : "")
        );
      }
      return "";
    },
    chatTime(date) {
      return moment(date).format("HH:mm");
    },
    // fetch messages from server if already chat happened
    fetchMessages() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${socket_url}/chat/get_message`,
          body: {
            chatroom_id: _self.$route.params.appid,
          },
        })
        .then((response) => {
          if (
            response &&
            response.status == "1000" &&
            response.data &&
            response.data.messages
          ) {
            _self.chatMsgs = response.data.messages;
            _self.pname = response.data.user.name;
            //_self.appId = _self.appDetails.apnt_id null;
            _self.pimg = response.data.user.img;
            setTimeout(function () {
              let msgDsp = _self.$refs.chatArea;
              if (msgDsp) msgDsp.scrollTop = msgDsp.scrollHeight;
            }, 100);
          }
        });
    },
    minMax() {
      const _self = this;
      if (!_self.minMaxFlag) {
        _self.chatPanel = true;
        _self.minMaxPanel = true;
        _self.minMaxFlag = true;
      } else {
        _self.chatPanel = false;
        _self.minMaxPanel = false;
        _self.minMaxFlag = false;
      }
    },
  },
  destroyed() {
    this.toggleBodyClass("removeClass", "sa-chat-vdo");
  },
};
</script>